import type { ReactNode } from 'react';

import { type Permissions, useRoles } from '../../../authz/providers/RoleProvider';
import { Error403Page } from '../../ErrorPage';

interface RequirePermissionProps {
  children: ReactNode;
  check: (permissions: Permissions) => boolean;
}

export const RequirePermission = ({ children, check }: RequirePermissionProps) => {
  const { permissions } = useRoles();

  if (!check(permissions)) return <Error403Page />;

  return <>{children}</>;
};
